<template>
  <div>
    <el-form :inline="true" :model="zskForm"  style="margin: 20px 0px">
      <el-form-item label="知识库类型">
        <el-select v-model="zskForm.categoryId" placeholder="请选择知识库类型！" clearable>
          <el-option v-for="(item,index) in zskTypeList" :label="item.categoryName" :value="item.id"
                     :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标题">
        <el-input v-model="zskForm.title" placeholder="请输入标题关键字" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryZsk">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="box">
      <ul v-for="(item,index) in zskList" :key="index">
        <li class="ggListStyle">
          <a style="display: flex;flex-flow: row nowrap; justify-content: space-between; height: 100%;" href="javascript:void(0);" @click="skipBtn(item)">
<!--            <span v-if="item.zdSta == '1'"><el-tag type="danger" effect="dark">置顶</el-tag></span>-->
            <span v-for="(typeitem,typeindex) in zskTypeList" :key="typeindex"><span v-if="typeitem.id == item.categoryId">【{{ typeitem.categoryName }}】</span></span>
            <span>
                  <span v-if="item.ydSta=='1'"><el-tag type="success" effect="plain">已读</el-tag></span>
                  <span v-else><el-tag type="info" effect="plain">未读</el-tag></span>
                </span>
            <!--              <span :style="item.ydSta=='1'? 'border: 1px solid green; color: green; padding: 1px' :'border: 1px solid red; color: red; padding: 1px'">{{item.ydSta=='1'?'已读':'未读'}}</span>-->
            <el-tooltip :content="item.title" placement="top" style="flex: 1"><span class="ggTitle">{{ item.title }}</span></el-tooltip><span style="float: right;">{{ item.createTime.split(" ")[0] }}</span></a></li>
      </ul>
      <div v-if="zskList.length > 0" class="content_page_box" style="text-align: right;background: #fff">
        <table-page :pagination="zskPagination" @change="zskPaginationChange"></table-page>
      </div>
      <div v-else>
        没有找到数据！
      </div>
    </div>
  </div>
</template>
<!--我的点赞/收藏 知识库-->
<script>
  import {mapGetters} from "vuex";
  import TablePage from "../../../../../src/components/TablePage";
  import {getAllList } from "@/api/cr/zsk/zskcategory";
  export default {
    name: "allZskNotifications",//知识库
    computed: {
      ...mapGetters([
        'userInfo'
      ])
    },
    props: {
      zskPagination: {
        type: Object
      },
      zskList: {
        type: Array
      }
    },
    data() {
      return {
        zskForm:{
          categoryId:'',//类目类型
          title:''
        },
        zskTypeList: [],
      }
    },
    created() {

      getAllList().then((res) => {
          this.zskTypeList = res.data.data;
      });
    },
    methods: {
      zskPaginationChange() {
        console.log("11111");
        this.$emit('zskPaginationChange');
      },
      queryZsk(){
       this.$emit('queryZsk',this.zskForm);

      },
      skipBtn(detail) {
        // this.$store.commit('SET_NOTICE_DETAIL', {
        //   detail: detail.content,
        //   title: detail.title,
        //   ydCount: detail.ydCount == 0 ? detail.ydCount + 1 : detail.ydCount ,
        //   createTime: detail.createTime,
        //   isAdmire: detail.isAdmire,
        //   isFavorites: detail.isFavorites,
        //   id: detail.id
        // });
        // if (detail.ydSta == 0) {
        //   submitRead({
        //     resType: 1,
        //     resId: detail.id,
        //     userId: this.userInfo.user_id,
        //     sourceFrom: 1
        //   })
        // }
        sessionStorage.setItem("zskDetail",JSON.stringify(detail));
        this.$router.push("/cr/zsk/zskDetail");
      },

    },
    components: {
      TablePage
    }
  }
</script>

<style lang="scss" scoped>
  .box li {
    padding-top: 8px;
    padding-bottom: 3px;
    border-bottom: 1px solid #eee;

    .ggListStyle {
      display: block;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid rgba(211, 211, 211, 0.5);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    a {
      width: 100%;
      overflow: hidden;
      display: inline-block;

      .red {
        color: red;
        padding: 2px;
        font-size: small;
        border: 1px solid red;
      }

      .green {
        color: green;
        padding: 2px;
        font-size: small;
        border: 1px solid green;
      }
    }
  }

</style>
